// extracted by mini-css-extract-plugin
module.exports = {"color":"style__color__5LC4A","swatch":"style__swatch__ByhiA","popover":"style__popover__6qbUX","cover":"style__cover__ccvT4"};